/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, FormText, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getPatientProcedures } from 'app/entities/patient-procedure/patient-procedure.reducer';
import { getEntities as getDoctors } from 'app/entities/doctor/doctor.reducer';
import { getEntities as getReferrals } from 'app/entities/referral/referral.reducer';
import { ProcedureNoteType } from 'app/shared/model/enumerations/procedure-note-type.model';
import { createEntity, getEntity, reset, updateEntity } from './patient-procedure-plan.reducer';

export const PatientProcedurePlanUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const patientProcedures = useAppSelector(state => state.patientProcedure.entities);
  const doctors = useAppSelector(state => state.doctor.entities);
  const referrals = useAppSelector(state => state.referral.entities);
  const patientProcedurePlanEntity = useAppSelector(state => state.patientProcedurePlan.entity);
  const loading = useAppSelector(state => state.patientProcedurePlan.loading);
  const updating = useAppSelector(state => state.patientProcedurePlan.updating);
  const updateSuccess = useAppSelector(state => state.patientProcedurePlan.updateSuccess);
  const procedureNoteTypeValues = Object.keys(ProcedureNoteType);

  const handleClose = () => {
    navigate(`/patient-procedure-plan${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getPatientProcedures({}));
    dispatch(getDoctors({}));
    dispatch(getReferrals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastupdated !== undefined && typeof values.lastupdated !== 'number') {
      values.lastupdated = Number(values.lastupdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampentry !== undefined && typeof values.timestampentry !== 'number') {
      values.timestampentry = Number(values.timestampentry);
    }

    const entity = {
      ...patientProcedurePlanEntity,
      ...values,
      procedure: patientProcedures.find(it => it.id.toString() === values.procedure?.toString()),
      recordedBy: doctors.find(it => it.id.toString() === values.recordedBy?.toString()),
      referral: referrals.find(it => it.id.toString() === values.referral?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          noteType: 'PREPROCEDURE',
          ...patientProcedurePlanEntity,
          procedure: patientProcedurePlanEntity?.procedure?.id,
          recordedBy: patientProcedurePlanEntity?.recordedBy?.id,
          referral: patientProcedurePlanEntity?.referral?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.patientProcedurePlan.home.createOrEditLabel" data-cy="PatientProcedurePlanCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.patientProcedurePlan.home.createOrEditLabel">
              Create or edit a PatientProcedurePlan
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="patient-procedure-plan-id"
                  label={translate('tinyMedicRestApp.patientProcedurePlan.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedurePlan.active')}
                id="patient-procedure-plan-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedurePlan.cursor')}
                id="patient-procedure-plan-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedurePlan.lastupdated')}
                id="patient-procedure-plan-lastupdated"
                name="lastupdated"
                data-cy="lastupdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedurePlan.microSec')}
                id="patient-procedure-plan-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedurePlan.timestampentry')}
                id="patient-procedure-plan-timestampentry"
                name="timestampentry"
                data-cy="timestampentry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedurePlan.notes')}
                id="patient-procedure-plan-notes"
                name="notes"
                data-cy="notes"
                type="text"
                validate={{
                  maxLength: { value: 225, message: translate('entity.validation.maxlength', { max: 225 }) },
                }}
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.patientProcedurePlan.noteType')}
                id="patient-procedure-plan-noteType"
                name="noteType"
                data-cy="noteType"
                type="select"
              >
                {procedureNoteTypeValues.map(procedureNoteType => (
                  <option value={procedureNoteType} key={procedureNoteType}>
                    {translate(`tinyMedicRestApp.ProcedureNoteType.${procedureNoteType}`)}
                  </option>
                ))}
              </ValidatedField>
              <ValidatedField
                id="patient-procedure-plan-procedure"
                name="procedure"
                data-cy="procedure"
                label={translate('tinyMedicRestApp.patientProcedurePlan.procedure')}
                type="select"
                required
              >
                <option value="" key="0" />
                {patientProcedures
                  ? patientProcedures.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <FormText>
                <Translate contentKey="entity.validation.required">This field is required.</Translate>
              </FormText>
              <ValidatedField
                id="patient-procedure-plan-recordedBy"
                name="recordedBy"
                data-cy="recordedBy"
                label={translate('tinyMedicRestApp.patientProcedurePlan.recordedBy')}
                type="select"
              >
                <option value="" key="0" />
                {doctors
                  ? doctors.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="patient-procedure-plan-referral"
                name="referral"
                data-cy="referral"
                label={translate('tinyMedicRestApp.patientProcedurePlan.referral')}
                type="select"
              >
                <option value="" key="0" />
                {referrals
                  ? referrals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/patient-procedure-plan" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default PatientProcedurePlanUpdate;
